(function () {
  'use strict';

  var qs = function (selector, context) { return (context || document).querySelector(selector); };
  var qsa = function (selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); };
  document.documentElement.classList.add('ps-js');

  var toastTimer;
  var toast = function (message) {
    var element = qs('#ps-toast');
    if (!element) return;
    element.textContent = message;
    element.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { element.classList.remove('is-visible'); }, 2600);
  };

  var menu = qs('.ps-mobile-toggle');
  if (menu) {
    menu.addEventListener('click', function () {
      var panel = qs('.ps-mobile-menu');
      if (!panel) return;
      var isOpen = panel.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', String(isOpen));
      menu.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    });
  }

  qsa('[data-ps-hero-image]').forEach(function (image) {
    image.addEventListener('error', function () {
      var hero = image.closest('.ps-home-hero');
      if (hero) hero.classList.add('is-image-failed');
    });
  });

  qsa('[data-product-gallery]').forEach(function (gallery) {
    var main = qs('[data-gallery-main]', gallery);
    var thumbs = qsa('[data-gallery-thumb]', gallery);
    if (!main || !thumbs.length) return;

    var choose = function (button) {
      var source = button.getAttribute('data-gallery-thumb');
      if (!source) return;
      main.src = source;
      main.alt = button.getAttribute('data-alt') || '';
      thumbs.forEach(function (item) { item.classList.toggle('is-active', item === button); });
    };

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { choose(thumb); });
    });

    qsa('[data-gallery-direction]', gallery).forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var currentIndex = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
        if (currentIndex < 0) currentIndex = 0;
        var direction = arrow.getAttribute('data-gallery-direction') === 'next' ? 1 : -1;
        var nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
        choose(thumbs[nextIndex]);
      });
    });
  });

  qsa('[data-qty-minus], [data-qty-plus]').forEach(function (button) {
    button.addEventListener('click', function () {
      var form = button.closest('form') || document;
      var input = qs('input[name="quantity"]', form);
      if (!input) return;
      var current = parseInt(input.value || '1', 10);
      if (Number.isNaN(current)) current = 1;
      input.value = Math.max(1, button.hasAttribute('data-qty-plus') ? current + 1 : current - 1);
    });
  });

  var money = function (amount) {
    var value = Number(amount || 0) / 100;
    return 'Rs.' + value.toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  qsa('[data-variant-picker]').forEach(function (picker) {
    var json = qs('[data-variant-json]', picker);
    var productInfo = picker.closest('.ps-product-info');
    if (!json || !productInfo) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }
    var form = qs('form[action="/cart/add"]', productInfo);
    var idInput = form ? qs('input[name="id"]', form) : null;
    var price = qs('[data-variant-price]', productInfo);
    var compare = qs('[data-variant-compare]', productInfo);
    var discount = qs('[data-variant-discount]', productInfo);
    var availability = qs('[data-variant-availability]', productInfo);
    var galleryImage = qs('[data-gallery-main]');
    var gallery = qs('[data-product-gallery]');

    var update = function () {
      var choices = qsa('fieldset', picker).map(function (field) {
        var input = qs('input:checked', field);
        return input ? input.value : '';
      });
      var variant = variants.find(function (candidate) {
        return candidate.options && candidate.options.every(function (value, index) { return value === choices[index]; });
      });
      qsa('[data-variant-selected]', picker).forEach(function (label, index) { label.textContent = choices[index] || ''; });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        var showCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !showCompare;
        if (showCompare) compare.textContent = money(variant.compare_at_price);
      }
      if (discount) {
        var oldPrice = Number(variant.compare_at_price || 0);
        var newPrice = Number(variant.price || 0);
        var percent = oldPrice > newPrice ? Math.round((oldPrice - newPrice) * 100 / oldPrice) : 0;
        discount.hidden = !percent;
        if (percent) discount.textContent = 'SAVE ' + percent + '%';
      }
      if (availability) availability.textContent = variant.available ? 'In stock' : 'Sold out';
      if (galleryImage && variant.featured_image && variant.featured_image.src) {
        galleryImage.src = variant.featured_image.src;
        if (gallery) qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) { thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === variant.featured_image.src); });
      }
    };
    qsa('input', picker).forEach(function (input) { input.addEventListener('change', update); });
    update();
  });

  qsa('[data-tabs]').forEach(function (tabs) {
    var buttons = qsa('[data-tab-button]', tabs);
    var panels = qsa('[data-tab-panel]', tabs);
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = button.getAttribute('data-tab-button');
        buttons.forEach(function (item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        panels.forEach(function (panel) { panel.hidden = panel.getAttribute('data-tab-panel') !== selected; });
      });
    });
  });

  qsa('[data-ps-video-card]').forEach(function (card) {
    var video = qs('[data-ps-video]', card);
    var control = qs('[data-ps-video-toggle]', card);
    var status = qs('[data-ps-video-status]', card);
    if (!video || !control) return;

    var setVideoState = function (playing) {
      card.classList.toggle('is-playing', playing);
      card.setAttribute('aria-pressed', String(playing));
      card.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' video');
      control.textContent = playing ? '❚❚' : '▶';
      if (status && playing) status.textContent = '';
    };

    var toggleVideo = function () {
      if (video.paused || video.ended) {
        video.muted = true;
        video.playsInline = true;
        if (status) status.textContent = 'Loading video…';
        var playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(function () {
            if (status) status.textContent = 'Video could not start. Tap once more.';
            setVideoState(false);
          });
        }
      } else {
        video.pause();
      }
    };

    card.addEventListener('click', toggleVideo);
    card.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleVideo();
      }
    });
    video.addEventListener('play', function () { setVideoState(true); });
    video.addEventListener('pause', function () { if (!video.ended) setVideoState(false); });
    video.addEventListener('ended', function () {
      video.currentTime = 0;
      setVideoState(false);
    });
    video.addEventListener('error', function () {
      if (status) status.textContent = 'Video is temporarily unavailable.';
      setVideoState(false);
    });
  });

  var sticky = qs('[data-sticky-atc]');
  if (sticky) {
    var onScroll = function () { sticky.classList.toggle('is-visible', window.scrollY > 530); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  qsa('.ps-product-form form[action="/cart/add"]').forEach(function (form) {
    var submitting = false;

    form.addEventListener('submit', function (event) {
      event.stopImmediatePropagation();
      var submitter = event.submitter;
      if (!submitter || (submitter.name !== 'add' && submitter.name !== 'checkout')) return;

      event.preventDefault();
      if (submitting) return;

      var idInput = qs('input[name="id"]', form);
      var quantityInput = qs('input[name="quantity"]', form);
      var variantId = idInput ? Number(idInput.value) : 0;
      var quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;

      if (!variantId) {
        toast('Please select a product option.');
        return;
      }

      if (Number.isNaN(quantity) || quantity < 1) quantity = 1;

      submitting = true;
      submitter.disabled = true;

      fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart could not be loaded.');
          return response.json();
        })
        .then(function (cart) {
          var existing = (cart.items || []).find(function (item) {
            return Number(item.variant_id) === variantId;
          });

          if (existing) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              credentials: 'same-origin',
              body: JSON.stringify({ id: existing.key, quantity: quantity })
            });
          }

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart could not be updated.');
          return response.json();
        })
        .then(function () {
          toast(quantity === 1 ? '1 product added to cart' : quantity + ' products added to cart');
          window.location.href = submitter.name === 'checkout' ? '/checkout' : '/cart';
        })
        .catch(function () {
          submitting = false;
          submitter.disabled = false;
          toast('Cart update failed. Please try again.');
        });
    }, true);
  });

  qsa('form[action="/cart/add"]').forEach(function (form) {
    if (form.closest('.ps-product-form')) return;
    form.addEventListener('submit', function () { toast('Product added to cart'); });
  });

  qsa('[data-copy-link]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(window.location.href);
      toast('Product link copied');
    });
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -42px 0px' });
    qsa('[data-ps-reveal]').forEach(function (element) { observer.observe(element); });
  } else {
    qsa('[data-ps-reveal]').forEach(function (element) { element.classList.add('is-revealed'); });
  }
}());
